const state = {
  id: null,
  key: null,
  mediaType: '',
  type: '',
  bgColor: '',
  imgSrc: ''
};

export const getters = {
  getActiveItem(state) {
    return state;
  },
};

const actions = {
  setActiveItem({ commit }, item) {
    commit('setActiveItem', item);
  },
  resetActiveItem({ commit }) {
    const item = {
      id: null,
      key: null,
      mediaType: '',
      type: '',
      bgColor: '',
      imgSrc: ''
    };

    commit('setActiveItem', item);
  },
};

const mutations = {
  setActiveItem(state, item) {
    state.id = item.id;
    state.key = item.key;
    state.mediaType = item.mediaType;
    state.type = item.type;
    state.bgColor = item.bgColor || 'red';
    state.imgSrc = item.imgSrc || '';
  }
};

const namespaced = true;

export const activeItem = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
